// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {useSelector} from 'react-redux';

// Components
import Form from '../core/form';
import NetworkSelect from './network-select';

// Styles
import './select-network-form.scss';

function SelectNetworkForm({className, formName}) {
    const networks = useSelector((state) => state?.servicesSearchData?.networksSelect?.searchData?.content);

    const formProps = {
        className: classnames('select-network-form', className),
        fixedPositionedResponse: true,
        name: formName,
        submitData: true,
    };

    return (
        <Form {...formProps}>
            <NetworkSelect
                disabled={!networks || !networks.length ? 'true' : 'false'}
                label="Network"
                name="network.name"
                placeholder={networks && networks.length ? 'Choose a Network' : 'Loading...'}
                singleSelect={true}
            />
        </Form>
    );
}

SelectNetworkForm.propTypes = {
    className: PropTypes.string,
    editing: PropTypes.bool,
    formName: PropTypes.string.isRequired,
};

export default SelectNetworkForm;
